import React from "react";
import {
  Box,
  InputBase,
  makeStyles,
  Typography,
  Button,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  inputWithLabelContainer: {
    marginBottom: "2.4rem",
  },

  inputContainer: {
    background: "#FFFFFF",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    borderRadius: "8px",
    display: "flex",

    alignItems: "center",
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: 6,
  },

  headingDesc: {
    fontWeight: "400",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    color: "rgba(0,0,0, 0.46)",
  },

  input: {
    height: (props) => (props.height ? props.height : 40),
    padding: "8px 1.2rem",

    display: "flex",
    alignItems: "flex-start",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    fontWeight: "400",
  },

  label: {
    marginBottom: "1.2rem",
    fontWeight: "600",
    fontSize: "1.6rem",
    lineHeight: "2.1rem",
  },

  uploadBtn: {
    minWidth: "9rem",
    height: "2.6rem",
  },

  uploadBtnText: {
    fontWeight: "600",
    fontSize: "1.1rem",
    lineHeight: "2rem",
  },
}));

const FileInput = ({ label, placeholder, value, setValue, height }) => {
  const classes = useStyles({ height });

  return (
    <Box className={classes.inputWithLabelContainer}>
      <Typography className={classes.label}>{label}</Typography>
      <Box className={classes.inputContainer}>
        <Button
          variant="outlined"
          component="label"
          className={classes.uploadBtn}
        >
          <Typography className={classes.uploadBtnText}>Browse File</Typography>
          <input type="file" hidden />
        </Button>
        <InputBase
          className={classes.input}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          multiline={height}
        />
      </Box>
    </Box>
  );
};

export default FileInput;
